module.exports = __webpack_public_path__ + "static/media/background.e3163835.png";